<div class="app-layout-wrapper">
  <div class="app-layout-content">
    <app-main-navigation
      class="app-main-navigation"
      [title]="'navigation.title'"
      [links]="links"
      data-test-id="app-layout-main-navigation"
      [userRoles]="user?.roles"
    ></app-main-navigation>
    <main data-test-id="app-layout-main">
      <router-outlet data-test-id="app-layout-router-outlet"></router-outlet>
    </main>
  </div>
  <app-topbar
    class="app-topbar"
    [user]="user"
    data-test-id="app-layout-topbar"
  ></app-topbar>
</div>
<app-toast></app-toast>
